import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
// import { TerrainService } from '../../services/terrain.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { TerrainDto } from '@cradua/data';

@Component({
  selector: 'cradua-terrain',
  templateUrl: './terrain.component.html',
  styleUrls: ['./terrain.component.scss'],
})
export class TerrainComponent implements OnChanges {
  terrainForm: FormGroup;
  terrainFormArray: FormGroup;
  control = new FormControl();
  @Input() terrains: TerrainDto[];
  @Input() routeAnimationsElements: any;
  @Output() terrain = new EventEmitter<TerrainDto[]>();
  @Output() deleteTerrainEvent = new EventEmitter<any>();

  selectedTerrain: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createTerrainForm();
  }

  createTerrainForm() {
    this.terrainForm = this.fb.group({
      TerrainName: ['', Validators.required],
      Rate: ['', Validators.required],
      Status: [''],
      Remarks: [''],
      TerrainDate: [''],
      id: null,
    });
    this.terrainFormArray = this.fb.group({ Terrains: this.fb.array([]) });
    this.setTerrain();
  }

  // method to display terrains
  setTerrain() {
    const control = this.terrainFormArray.controls.Terrains as FormArray;
    this.terrains.forEach((e) => {
      control.push(
        this.fb.group({
          TerrainName: e.TerrainName,
          TerrainDate: e.TerrainDate,
          Status: e.Status,
          Remarks: e.Remarks,
          Rate: e.Rate,
          id: e.id,
        })
      );
    });
  }

  // method to add Terrain
  addTerrain(value: TerrainDto) {
    const control = this.terrainFormArray.controls.Terrains as FormArray;
    control.insert(
      0,
      this.fb.group({
        TerrainName: value.TerrainName,
        TerrainDate: value.TerrainDate,
        Status: value.Status,
        Remarks: value.Remarks,
        Rate: value.Rate,
        id: null,
      })
    );
  }

  selectTerrain(value) {}

  // method to delete terrain from arrary list
  deleteTerrain(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.terrainFormArray.controls.Terrains as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.terrains.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.terrains[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: TerrainDto) {
    if (this.terrainForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.terrainFormArray
        .get('Terrains')
        ['controls'][this.selectedIndex].patchValue({
          TerrainName: formValue.TerrainName,
          Rate: formValue.Rate,
          Status: formValue.Status,
          Remarks: formValue.Remarks,
          TerrainDate: formValue.TerrainDate
        });
    } else {
      this.addTerrain(formValue);
    }
    this.selectedIndex = null;
    this.terrainForm.reset();
  }

  onEdit(index, value: TerrainDto) {

    this.selectedIndex = index;
    this.terrainForm.patchValue({ ...value, TerrainDate: value.TerrainDate != null ? this.formatDate(value.TerrainDate) : null });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.terrainForm.reset();
  }

  onSubmit(formValue: TerrainDto[]) {
    this.terrain.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteTerrainEvent.emit(this.filteredDelete);
    }
  }

  formatDate(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }
}
